import DatePicker from 'vue2-datepicker';
import appStrings from '@/app/utility/string.utility';
import commonHelper from '@/app/utility/common.helper.utility';
export default {
  name: 'addIsdRevenue',
  components: { DatePicker },
  data() {
    return {
      financialYear: {
        text: null,
        value: null
      },
      legalEntity: {
        text: null,
        value: null
      },
      showValueSetModal: false,
      totalRows: null,
      currentPage: 1,
      perPage: commonHelper.perPageRecord,
      pageOptions: commonHelper.getPageOption(),
      addIsdRevenueData: [
        {
          gstn_no: null,
          revenue_amount: null
        }
      ],
      addIsdRevenueFields: [
        {
          key: 'gstn_no',
          label: 'GSTN Number',
          class: 'text-center'
        },
        {
          key: 'revenue_amount',
          label: 'Revenue Amount',
          class: 'text-center'
        },
        {
          key: 'add',
          stickyColumn: true,
          class: 'text-center'
        },
        {
          key: 'remove',
          stickyColumn: true,
          class: 'text-center'
        }
      ],
      parent_value_set_id: null,
      specIndex: null,
      editMode: true,
      loader: false
    };
  },
  mounted() {
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'shared/setActionName') {
        const actionName = state.shared.actionName;
        if (actionName === 'save') {
          if (this.legalEntity.value && this.financialYear.value) {
            this.postIsdRevenueData();
          } else {
            this.$bvToast.toast('Please Select mandatory Fields', {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
          }
        }
        if (actionName === 'update' && !this.showEditIsdRevenueModal) {
          this.editMode = true;
        }
      }
    });
  },
  methods: {
    openValueSetModal(vsetCode, index) {
      this.specIndex = index;
      this.vsetCode = vsetCode;
      this.showValueSetModal = true;
      if (this.vsetCode === appStrings.VALUESETTYPE.GST_REGULAR_GSTN_VS) {
        this.parent_value_set_id = this.legalEntity.value;
      }
      this.setTimeVsetCode = setTimeout(() => {
        const vSetData = {
          valueSetName: vsetCode,
          multiFlag: null
        };
        this.eventBus.$emit('valueSetCode', vSetData);
      }, 0);
    },
    selectedvalueSet(item) {
      if (this.vsetCode === appStrings.VALUESETTYPE.LEGAL_ENTITY_LIST) {
        this.legalEntity = {
          text: item.value_code,
          value: item.value_set_dtl_id
        };
      } else if (this.vsetCode === appStrings.VALUESETTYPE.CUSTOM_FY) {
        this.financialYear = {
          text: item.value_meaning,
          value: item.value_code
        };
      } else if (
        this.vsetCode === appStrings.VALUESETTYPE.GST_REGULAR_GSTN_VS
      ) {
        const selectedGstn = item.gst_number;
        const isAlreadySelected = this.addIsdRevenueData.some(
          (data, index) =>
            data.gstn_no === selectedGstn && index !== this.specIndex
        );
        if (isAlreadySelected) {
          alert(' GSTN is already selected!');
        } else {
          this.addIsdRevenueData[this.specIndex].gstn_no = selectedGstn;
        }
      }
    },
    closeValueSetModal() {
      this.showValueSetModal = false;
    },
    clearVsetValues(vsetCode, index) {
      this.specIndex = index;
      if (vsetCode === 'LEGAL_ENTITY_LIST') {
        this.legalEntity = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'CUSTOM_FY') {
        this.financialYear = {
          text: null,
          value: null
        };
      } else if (vsetCode === 'GST_REGULAR_GSTN_VS') {
        this.this.addIsdRevenueData[this.specIndex].gstn_no = null;
      }
    },
    addNewRow() {
      this.addIsdRevenueData.push({
        gstn_no: null,
        revenue_amount: null
      });
    },
    removeRow(index) {
      this.addIsdRevenueData.splice(index, 1);
    },
    postIsdRevenueData() {
      let isdRevenueData = [];
      isdRevenueData = this.addIsdRevenueData.map(item => {
        return {
          gstn_no: item.gstn_no,
          revenue_amount: item.revenue_amount
        };
      });
      if (isdRevenueData.length) {
        if (
          isdRevenueData[0].gstn_no === null &&
          isdRevenueData[0].revenue_amount === null
        ) {
          isdRevenueData = [];
        } else {
          isdRevenueData;
        }
      }
      const payload = {
        le_id: Number(this.legalEntity.value),
        fin_year: this.financialYear.value,
        page: isdRevenueData
      };
      this.loader = true;
      this.$store
        .dispatch('isdRevenue/postIsdRevenueData', payload)
        .then(response => {
          this.loader = false;
          if (response.status === 200) {
            this.editMode = false;
            this.$bvToast.toast(response.data.message, {
              title: 'Alert',
              variant: 'success',
              solid: true
            });
          } else {
            this.loader = false;
            let message2 = response.response.data['page[0].gstnNo'];
            this.$bvToast.toast(response.response.data.message, {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
            this.$bvToast.toast(message2, {
              title: 'Alert',
              variant: 'danger',
              solid: true
            });
          }
        })

        .catch(err => {
          this.err = err;
          this.loader = false;
        });
    }
  },
  beforeDestroy() {
    this.unsubscribe();
  }
};
